module.exports = __webpack_public_path__ + "static/media/emna.cbc382f6.JPG";